var render, staticRenderFns
var script = {}
import style0 from "./style.vue?vue&type=style&index=0&id=da612b0a&prod&scoped=true&lang=less&"
import style1 from "./style.vue?vue&type=style&index=1&id=da612b0a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da612b0a",
  null
  
)

export default component.exports